import ExecutaRest from '../util/ExecutaRest'

class ClassificacaoApi {

    static ListarClassificacao() {

        var rest = new ExecutaRest();

        return new Promise(function (resolve, reject) {

            rest.Post('ClassificacaoSL.svc/rest/ListarClassificacaoREST', null).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
            }).catch(error => {
                reject('Ocorreu um erro inesperado em --> ListarClassificacao: ' + error /*areaTratamento.statusText*/);
            });

        });

    }

}

export default ClassificacaoApi;


/** WEBPACK FOOTER **
 ** ./src/components/api/classificacaoApi.js
 **/